import React, { Component } from 'react';
class RichMenuTemplate extends Component {
    render() {
        let layout = this.props.layout.template;
        let nrow = layout.length;
        let rows = [];
        for (var r = 0; r < nrow; r++) {
            let cols = [];
            for (var c = 0; c < layout[r]; c++) {
                let itemName = (r + 1) + '-' + (c + 1);
                cols.push(<div key={itemName} className="column" role={'gridcell'}>{r + 1}-{c + 1}</div>)
            }

            rows.push(<div key={r} className={"columns is-mobile r" + nrow}>{cols}</div>)
        }
        return (
            <div
                className={`rich-menu-layout layout-${this.props.layout.type} ${this.props.active ? 'active' : ''}`}
                onClick={this.props.onClick}
                style={{ backgroundImage: `url(${this.props.src})` }}>{rows}</div>
        )
    }
}
export default RichMenuTemplate